module.exports = __webpack_public_path__ + "img/card_payment3.549a2afc.svg";